import React from 'react';
import PropTypes from 'prop-types';
import { CustomFeeDisplay } from './CustomFee';

const CustomFeeList = ({
  propertyCustomFees,
  removeCustomFee,
}) => (
  <div className="property-info-edit-field-input">
    {propertyCustomFees.map((fee, index) => {
      const { amount, name } = fee;

      return (
        <span className="inline-block side-margin-lg" key={index}>
          <span>
            {`${name}: `} <CustomFeeDisplay amount={amount} />
            <button
              className="knock-react-button btn-danger btn-checkbox-inline"
              id="removeFeeButton"
              data-testid={`removeFeeButton-${index}`}
              onClick={() => removeCustomFee(index)}
            >
              <i className="fa fa-times" />
            </button>
          </span>
        </span>
      );
    })}
  </div>
);

CustomFeeList.propTypes = {
  propertyCustomFees: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      amount: PropTypes.number,
    })
  ),
  removeCustomFee: PropTypes.func,
};

export default CustomFeeList;
